import React from "react";
import Reveal from "../common/Reveal";
import NetworkBackground from "../common/NetworkBackground";

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-primary-50 to-white">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <NetworkBackground className="absolute inset-0 h-full w-full" density={40} />
      </div>

      <div className="relative mx-auto max-w-3xl px-4 py-16 text-center sm:px-6 lg:px-8 lg:py-24">
        <Reveal>
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-sm font-semibold tracking-wide text-primary-700">
            MISSION &amp; VISION
          </span>
          <h1 className="mt-6 break-keep text-4xl font-bold leading-tight text-primary-900 sm:text-5xl">
            우리가 나아가는 길
          </h1>
          <p className="mx-auto mt-6 max-w-xl break-keep text-lg leading-relaxed text-gray-600">
            MTST는 데이터와 기술로 제조의 미래를 그려갑니다. 우리가 무엇을 위해
            일하고, 어디를 향해 나아가는지를 이렇게 정의합니다.
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Hero;
